import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import LocalProvider from "./LocalProvider";
import * as serviceWorker from "./serviceWorker";
import { persistor, store } from "./store";
import fetchInterceptor from "./utils/fetchInterceptor";

// setup fetch interceptor to setup headers
fetchInterceptor.setup(store);

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <LocalProvider>
          <Router>
            <App />
          </Router>
        </LocalProvider>
      </PersistGate>
    </Provider>
  </StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
